app.controller('dashboardDocumentDetailsOptionsCtrl', [
    '$scope', '$rootScope','documentDetailIdGenerator',
    function ($scope, $rootScope,documentDetailIdGenerator) {

        $scope.viewWidgets = documentDetailIdGenerator.viewWidgets;
    }
]);